/*
 * Copyright (c) Volvo Group. All rights reserved.
 * SPDX-License-Identifier: ISC
 */

import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type RootState } from "../../../store/Types";
import { type SnackbarVariant } from "@volvo/vcdk/snackbar";

const SLICE_NAME = "notifications";

export type NotificationItem = {
  message: string;
  variant: SnackbarVariant;
};

type NotificationState = {
  notification: NotificationItem[];
};

export const initialNotificationState: NotificationState = {
  notification: [],
};

const notificationSlice = createSlice({
  name: SLICE_NAME,
  initialState: initialNotificationState,
  reducers: {
    addMessage: (
      state,
      { payload: message }: PayloadAction<NotificationItem>,
    ) => {
      state.notification = [...state.notification, message];
    },
    removeMessage: (
      state,
      { payload: message }: PayloadAction<NotificationItem>,
    ) => {
      state.notification = state.notification.filter(
        (x) => x.message !== message.message,
      );
    },
  },
});

export const { addMessage, removeMessage } = notificationSlice.actions;
export const selectMessages = (state: RootState) =>
  state.notifications.notification;

export default notificationSlice.reducer;
